import {
  GOLDPRICE_ALL,
  GOLDPRICE_GET,
  GOLDPRICE_DELETE,
  GOLDPRICE_PUT,
  GOLDPRICE_POST,
  GOLDPRICE_LOADING,
  GOLDPRICE_ERROR,
  GOLDPRICE_RESET,
} from '../../actions/types';

const initialState = {
  goldprice: null,
  isLoading: true,
  isCompleted: true,
};

// eslint-disable-next-line func-names
export default function (state = initialState, action) {
  switch (action.type) {
    case GOLDPRICE_ALL:
      return {
        ...action.payload,
        isLoading: false,
        isCompleted: true,
      };
    case GOLDPRICE_GET:
      return {
        ...action.payload,
        isLoading: false,
        isCompleted: true,
      };
    case GOLDPRICE_POST:
      return { isLoading: false, isCompleted: true };
    case GOLDPRICE_PUT:
      return { isLoading: false, isCompleted: true };
    case GOLDPRICE_DELETE:
      return { isLoading: false, isCompleted: true };
    case GOLDPRICE_RESET:
      return { employee: null, isLoading: true, isCompleted: true };
    case GOLDPRICE_LOADING:
      return { isLoading: true, isCompleted: true };
    case GOLDPRICE_ERROR:
      return { isLoading: false, isCompleted: false };
    default:
      return state;
  }
}
